import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Inspection } from '../../shared/interfaces';
import { InspectionService } from '../inspection.service';
import { dateAsString } from '../../shared/date.helper';

@Component({
  selector: 'app-set-violation-deadlines',
  templateUrl: './set.violation.deadlines.component.html',
})
export class InspectionSetDeadlinesComponent implements OnInit {
  @ViewChild('setDatesModal', { static: true }) public setDatesModal: ModalDirective;

  confirmCallback: () => void;
  cancelCallback: () => void;
  inspection: Inspection;

  addDateForm: UntypedFormGroup;

  dateConfig = { dateInputFormat: 'MM-DD-YYYY', customTodayClass: 'date-today' };
  saving = false;

  constructor(
    public inspectionService: InspectionService,
    private fb: UntypedFormBuilder,
  ) {}

  ngOnInit() {
    this.addDateForm = this.fb.group({
      violationRecommendedDeadline: '',
      violationActionRequiredDeadline: '',
    });

    this.setDatesModal.onHidden.subscribe(x => {
      if (x.dismissReason === 'esc' || x.dismissReason === 'backdrop-click') {
        this.cancel();
      }
    });
  }

  show(options: { confirmed?: () => void; canceled?: () => void; inspection: Inspection }) {
    this.confirmCallback = options.confirmed;
    this.cancelCallback = options.canceled;
    this.inspection = options.inspection;

    if (this.inspection.dueDate) {
      this.addDateForm
        .get('violationActionRequiredDeadline')
        .setValue(
          this.inspection.violationActionRequiredDeadline
            ? new Date(this.inspection.violationActionRequiredDeadline)
            : null,
        );

      this.addDateForm
        .get('violationRecommendedDeadline')
        .setValue(
          this.inspection.violationRecommendedDeadline ? new Date(this.inspection.violationRecommendedDeadline) : null,
        );
    }
    this.setDatesModal.show();
  }

  async save() {
    if (this.saving) return;
    if (this.addDateForm.valid) {
      this.saving = true;
      await this.inspectionService.setDeadlines(this.inspection.id, this.addDateForm.value);
      Object.assign(this.inspection, this.addDateForm.value);
      this.setDatesModal.hide();
      this.saving = false;
      return this.confirmCallback && this.confirmCallback();
    }
  }

  cancel() {
    this.setDatesModal.hide();
    return !!this.cancelCallback && this.cancelCallback();
  }

  setDeadline(to, field) {
    switch (to) {
      case '+30d':
        const d30 = new Date();
        d30.setDate(d30.getDate() + 30);
        this.addDateForm.get(field).setValue(dateAsString(d30));
        break;

      case '+60d':
        const d60 = new Date();
        d60.setDate(d60.getDate() + 60);
        this.addDateForm.get(field).setValue(dateAsString(d60));
        break;

      case '+90d':
        const d90 = new Date();
        d90.setDate(d90.getDate() + 90);
        this.addDateForm.get(field).setValue(dateAsString(d90));
        break;
    }
  }
}
